<template>
    <v-app class="homepage">
        <div @mouseleave="handleMouseLeave">


        <div class="homepage__container homepage__white" >
            <v-container class="main-block">
                <v-layout wrap row class="homepage__title-layout">
                    <v-flex xs12 md6 class="homepage__title">
                        <v-flex hidden-sm-and-down class="homepage__title__desktop">
                            <h1 v-html="headerTitle"></h1>
                        </v-flex>
                        <v-flex hidden-md-and-up>
                            <h1>Узнай цену <br>ОСАГО</h1>
                        </v-flex>
                        <p class="homepage__title__text">
                            Сравните предложения в <b>15 страховых компаниях</b> и оформите полис <b>за 5 минут</b> по лучшей цене.<br>Наши клиенты <b>экономят до 3500 руб.</b>
                        </p>
                        <osago-calc-form
                            :buttonText="'Рассчитать цену'"
                        />
                        <v-flex class="homepage__title__slogan" hidden-md-and-up>
                            <p>Мы не навязываем лишние опции и учитываем все скидки. Гарантируем подлинность. Введите данные всего один раз и используйте их всегда.</p>
                        </v-flex>
                    </v-flex>
                    <v-flex md6 hidden-sm-and-down class="homepage__desktop">
                        <div class="homepage__desktop__background">
                            <img :src="'/img/home/iphone.png'"/>
                        </div>
                        <div class="homepage__desktop__gif">
                            <img :src="'/img/home/Getpolis.gif'"/>
                        </div>
                        <div class="homepage__desktop__circle">
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        <div class="homepage__container">
            <v-container class="homepage__container-slogan" hidden-sm-and-down>
                <v-flex class="homepage__slogan">
                    <p>Мы не навязываем лишние опции и учитываем все скидки. Гарантируем подлинность. Введите данные всего один раз и используйте их всегда.</p>
                </v-flex>
            </v-container>
        </div>
        <services-list />
        <div class="homepage__container">
            <v-container class="homepage__container-slogan">
                <osago-partners
                    :showOnMobile = "true"
                ></osago-partners>
                <v-flex class="homepage__second-form">
                    <h3>У вас надежные партнеры.<br>Хочу ОСАГО в одной из этих компаний.</h3>
                    <osago-calc-form
                        :buttonText="'Узнать стоимость'"
                    />
                </v-flex>
            </v-container>
        </div>
        <div class="homepage__container homepage__white homepage__container__overflow-hidden">
            <v-container class="homepage__container-how-it-work">
                <h2>Как работает <br>ОСАГО онлайн</h2>
                <v-layout wrap row class="homepage__container-how-it-work__list" hidden-sm-and-down>
                    <v-flex class="homepage__container-how-it-work__list__item" md7>
                        <v-flex class="homepage__container-how-it-work__list__item__number">1</v-flex>
                        <v-flex class="homepage__container-how-it-work__list__item__text">
                            <h4>Заявка</h4>
                            <p>Введите гос номер вашего автомобиля и мы заполним заявку за Вас автоматически</p>
                        </v-flex>
                    </v-flex>
                    <v-flex class="homepage__container-how-it-work__list__item" md5>
                        <v-flex class="homepage__container-how-it-work__list__item__number">2</v-flex>
                        <v-flex class="homepage__container-how-it-work__list__item__text">
                            <h4>Выбор страховой</h4>
                            <p>Узнайте стоимость ОСАГО<br>со скидкой за безаварийность онлайн, сравните цены, выберите страховую</p>
                        </v-flex>
                    </v-flex>
                    <v-flex class="homepage__container-how-it-work__list__item" md7>
                        <v-flex class="homepage__container-how-it-work__list__item__number">3</v-flex>
                        <v-flex class="homepage__container-how-it-work__list__item__text">
                            <h4>Оплата</h4>
                            <p>Оплатите полис online<br>напрямую в страховую компанию картой любого банка</p>
                            <img :src="'/img/home/card.png'"/>
                        </v-flex>
                    </v-flex>
                    <v-flex class="homepage__container-how-it-work__list__item" md5>
                        <v-flex class="homepage__container-how-it-work__list__item__number green-background">4</v-flex>
                        <v-flex class="homepage__container-how-it-work__list__item__text">
                            <h4>Готово!</h4>
                            <p>Получите свой полис</p>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-flex xs12 class="homepage__container-how-it-work__mobile-images" hidden-md-and-up>
                    <img class="homepage__container-how-it-work__mobile-images__1" :src="'/img/home/mobile_1.png'">
                    <img class="homepage__container-how-it-work__mobile-images__main" :src="'/img/home/ready.gif'">
                    <img class="homepage__container-how-it-work__mobile-images__2" :src="'/img/home/mobile_2.png'">
                </v-flex>
                <v-layout wrap row class="homepage__container-how-it-work__mobile-list" hidden-md-and-up>
                    <v-flex class="homepage__container-how-it-work__mobile-list__item" xs6>
                        <v-flex class="homepage__container-how-it-work__mobile-list__item__number">1</v-flex>
                        <v-flex class="homepage__container-how-it-work__mobile-list__item__text">
                            <p>Введите гос номер вашего автомобиля и мы заполним заявку за Вас автоматически</p>
                        </v-flex>
                    </v-flex>
                    <v-flex class="homepage__container-how-it-work__mobile-list__item" xs5>
                        <v-flex class="homepage__container-how-it-work__mobile-list__item__number">2</v-flex>
                        <v-flex class="homepage__container-how-it-work__mobile-list__item__text">
                            <p>Узнайте стоимость ОСАГО<br>со скидкой за безаварийность онлайн, сравните цены, выберите страховую</p>
                        </v-flex>
                    </v-flex>
                    <v-flex class="homepage__container-how-it-work__mobile-list__item" xs6>
                        <v-flex class="homepage__container-how-it-work__mobile-list__item__number">3</v-flex>
                        <v-flex class="homepage__container-how-it-work__mobile-list__item__text">
                            <p>Оплатите полис online<br>напрямую в страховую компанию картой любого банка</p>
                        </v-flex>
                    </v-flex>
                    <v-flex class="homepage__container-how-it-work__mobile-list__item green-item" xs5>
                        <v-flex class="homepage__container-how-it-work__mobile-list__item__number green-background">4</v-flex>
                        <v-flex class="homepage__container-how-it-work__mobile-list__item__text">
                            <p>Получите свой полис</p>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-flex class="homepage__second-form">
                    <h3>У вас реально быстро!<br>Хочу узнать цену ОСАГО за 5 минут.</h3>
                    <osago-calc-form
                        :buttonText="'Узнать цену'"
                    />
                </v-flex>
            </v-container>
        </div>
        <div class="homepage__container">
            <v-container class="homepage__container-why-choose-us" id="chooseContainer">
                <h2>Почему<br>нас выбирают<br><span class="grey-text">9 причин за</span></h2>
                <v-flex class="homepage__container-why-choose-us__inner" hidden-sm-and-down>
                    <v-layout wrap row class="homepage__container-why-choose-us__block" hidden-sm-and-down id="choose1" style="top:0px">
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>ОСАГО<br>без ограничений<br>по региону</h4>
                            <p>Заполните заявку на полис ОСАГО без визита в офис. Оформим страховку онлайн<br>вне зависимости от региона.<br>Полис ОСАГО придет<br>на электронную почту сразу после оплаты.</p>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Самые выгодные<br>предложения<br>по ОСАГО</h4>
                            <p>Не навязываем лишние опции.</p>
                            <img :src="'/img/home/1.png'" class="image_1"/>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Напомним<br>об окончании страховки<br>по смс</h4>
                            <p>Продление полиса займет<br>2 минуты.</p>
                        </v-flex>
                    </v-layout>

                    <v-layout wrap row class="homepage__container-why-choose-us__block green-gradient" hidden-sm-and-down id="choose2" style="top:563px">
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Учитываем все коэффициенты<br>и скидки за безаварийность</h4>
                            <p>Рассчитаем точную стоимость учитывая все параметры.</p>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>За 5 минут,<br>не выходя<br>из дома</h4>
                            <img :src="'/img/home/watch_5.png'" class="image_2"/>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Клиентская поддержка</h4>
                            <p>Мы ответим и проконсультируем по любым вопросам.</p>
                        </v-flex>
                    </v-layout>

                    <v-layout wrap row class="homepage__container-why-choose-us__block" hidden-sm-and-down id="choose3" style="top:1161px">
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Удобно, быстро,<br>без очередей</h4>
                            <img :src="'/img/home/2.png'" class="image_1"/>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Введите данные всего один раз<br>и используйте их<br>при следующих покупках</h4>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Получаете<br>оригинальный полис.<br>Подделка исключена</h4>
                            <p>Проверьте подлинность <a :href="'https://dkbm-web.autoins.ru/dkbm-web-1.0/policyInfo.htm'">на сайте Российского союза автостраховщиков</a> (РСА).</p>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-layout class="homepage__container-why-choose-us__slider" hidden-md-and-up>
                    <v-carousel
                        hide-controls
                    >
                        <v-carousel-item
                            v-for="(slide,i) in slides"
                            :key="i"
                            :interval="3000"
                            :src="slide.url"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                        ></v-carousel-item>
                    </v-carousel>
                </v-layout>

                <v-flex class="homepage__second-form">
                    <h3>Вы меня убедили!<br>Хочу рассчитать ОСАГО сейчас.</h3>
                    <osago-calc-form
                        :buttonText="'Рассчитать ОСАГО'"
                    />
                </v-flex>
            </v-container>
        </div>
        <div class="homepage__container homepage__white">
            <v-container class="homepage__container-faq">
                <h2>Частые вопросы</h2>
                <home-questions
                    :faq="faq"
                />
                <v-flex class="homepage__container-faq__link">
                    <a href="https://getpolis.ru/osago_faq">Все вопросы</a>
                </v-flex>
                <v-flex wrap row class="homepage__container-faq__any-question" hidden-sm-and-down>
                    <h3>Остались вопросы?</h3>
                    <v-flex class="homepage__container-faq__any-question__text">
                        <p>По любым вопросам пишите на <a href="mailto:mail@getpolis.ru">mail@getpolis.ru</a>, или звоните 8 800 201 06 43.<br>Расскажем, проконсультируем.</p>
                        <a class="black-button" @click="openFeedback">Задать вопрос</a>
                    </v-flex>
                </v-flex>
                <v-flex class="homepage__second-form">
                    <h3>У меня не осталось вопросов.<br>Куплю ОСАГО у вас.</h3>
                    <osago-calc-form
                        :buttonText="'Купить ОСАГО'"
                    />
                </v-flex>
            </v-container>
        </div>
        <homepage-feedback
            :dialog="dialog"
            @closeFeedback="closeFeedback"
        />
        <form-out-popup
            :dialog="isOut"
            @closeFeedback="closeFeedback"
        />
        </div>
    </v-app>
</template>
<script>
    export default {
        data: () => ({
            headerTitle: 'Узнай цену <br>ОСАГО',
            headerTitleItems: ['Калькулятор <br>ОСАГО 2021', 'Узнай цену <br>ОСАГО'],
            slides: [
                { url: '/img/home/slider/01.jpg' },
                { url: '/img/home/slider/02.jpg' },
                { url: '/img/home/slider/03.jpg' },
                { url: '/img/home/slider/04.jpg' },
                { url: '/img/home/slider/05.jpg' },
                { url: '/img/home/slider/06.jpg' },
                { url: '/img/home/slider/07.jpg' },
                { url: '/img/home/slider/08.jpg' },
                { url: '/img/home/slider/09.jpg' }
            ],
            faq: [
                {
                    question: 'Как купить страховой полис?',
                    answer: 'Наш агрегатор предлагает вам для сравнения страховые продукты разных компаний, выберите заинтересовавший вас полис. После оформления и оплаты страховая компания отправит его вам на электронную почту.',
                },
                {
                    question: 'На вашем сайте цены за страховку ниже, чем на сайтах страховых компаний?',
                    answer: 'Наши цены сопоставимы с ценами на сайтах страховых компаний. Однако у нас на сайте Вы можете сравнить предложения от различных страховых компаний и подобрать оптимальную для Вас страховку.',
                },
                {
                    question: 'Почему купить полис у вас выгоднее, чем в страховой компании?',
                    answer: 'Вы не тратите время на поиск полиса, а пользуетесь удобным сервисом сравнения предложений от страховых компаний. Кроме того, при покупке большинства страховок на нашем сайте, Вы получите полис на электронную почту, без посещения офиса страховой компании.',
                },
            ],
            regaliaArray: [
                {
                    logo: '/img/home/regalia/logo-skolkovo.svg',
                    text: `Участник фонда "Сколково"<br>Регистрационный номер №1127664`,
                },
                {
                    logo: '/img/home/regalia/logo-mincifry.png',
                    text: `В реестре аккредитованных<br>ИТ-компаний №48867`,
                },
                {
                    logo: '/img/home/regalia/logo-rospatent.png',
                    text: `Регистрация ПО в Роспатенте:<br>№2022617332`,
                },
                {
                    logo: '/img/home/regalia/logo-reestr-po.png',
                    text: `Реестр российского ПО<br>№2022617332`,
                },
            ],
            dialog: false,
            isOut: false,
        }),

        created: function() {
            this.changeTitle()
            this.$nextTick(() => {
                this.chooseScrollListener()
            })
            /*window.addEventListener('mouseleave', () => {
                console.log('Вышло')
                this.isOut = true;
            });*/
            /*window.addEventListener('mouseleave', this.handleMouseLeave);*/
        },

        methods: {
            openFeedback() {
                this.dialog = true
            },
            closeFeedback() {
                this.dialog = false
            },
            changeTitle() {
                let i = 0
                setInterval(() => {
                    this.headerTitle = this.headerTitleItems[i]
                    if (i == 1) {
                        i = 0
                    } else {
                        i++
                    }
                }, 6000)
            },
            toggleFAQ(item) {
                let elements = document.getElementsByClassName('homepage__container-faq__item__text')
                let textElement = elements[item]
                if (textElement.classList.contains('hide')) {
                    textElement.classList.remove('hide')
                    textElement.classList.add('show')
                    return
                }
                textElement.classList.add('hide')
                textElement.classList.remove('show')
            },
            chooseScrollListener(){
                let choose1 = document.getElementById('choose1')
                let choose2 = document.getElementById('choose2')
                let choose3 = document.getElementById('choose3')
                let point, point2
                window.addEventListener('scroll', (e) => {
                    if (window.screen.width > 960) {
                        point = Math.floor(choose2.getBoundingClientRect().top) - 800
                        point2 = Math.floor(choose3.getBoundingClientRect().top) - 800
                        if (point < 0) {
                            if (point > -100) {
                                choose1.style.position = 'fixed'
                                choose1.style.top = '100px'
                                choose1.style.opacity = 1
                                choose1.style.transform = 'scale(1)'
                            }
                            if (point <= -100 && point > -350) {
                                choose1.style.opacity = 1
                                choose1.style.transform = 'scale(1)'
                            }
                            if (point <= -350 && point > -450) {
                                choose1.style.opacity = 0.9
                                choose1.style.transform = 'scale(0.95)'
                            }
                            if (point <= -450 && point > -550) {
                                choose1.style.opacity = 0.8
                                choose1.style.transform = 'scale(0.9)'
                            }
                            if (point <= -550 && point > -650) {
                                choose1.style.opacity = 0.5
                                choose1.style.transform = 'scale(0.9)'
                            }
                            if (point <= -550) {
                                choose1.style.display = 'none'
                                choose1.style.position = 'fixed'
                                choose1.style.opacity = 0
                                choose1.style.transform = 'scale(0.95)'
                            } else {
                                choose1.style.display = 'flex'
                            }
                        } else {
                            choose1.style.display = 'flex'
                            choose1.style.position = 'absolute'
                            choose1.style.top = '0px'
                            choose1.style.opacity = 1
                            choose1.style.transform = 'scale(1)'
                        }

                        if (point2 < 0) {
                            if (point2 > -100) {
                                choose2.style.position = 'fixed'
                                choose2.style.top = '100px'
                                choose2.style.opacity = 1
                                choose2.style.transform = 'scale(1)'
                            }
                            if (point2 <= -100 && point2 > -350) {
                                choose2.style.opacity = 1
                                choose2.style.transform = 'scale(1)'
                            }
                            if (point2 <= -350 && point2 > -450) {
                                choose2.style.opacity = 0.9
                                choose2.style.transform = 'scale(0.95)'
                            }
                            if (point2 <= -450 && point2 > -550) {
                                choose2.style.opacity = 0.8
                                choose2.style.transform = 'scale(0.9)'
                            }
                            if (point2 <= -550 && point2 > -650) {
                                choose2.style.opacity = 0.5
                                choose2.style.transform = 'scale(0.9)'
                            }
                            if (point2 <= -550) {
                                choose2.style.display = 'none'
                                choose2.style.position = 'fixed'
                                choose2.style.opacity = 0
                                choose2.style.transform = 'scale(0.95)'
                            } else {
                                choose2.style.display = 'flex'
                            }
                        } else {
                            choose2.style.display = 'flex'
                            choose2.style.position = 'absolute'
                            choose2.style.top = '563px'
                            choose2.style.opacity = 1
                            choose2.style.transform = 'scale(1)'
                        }
                    }

                }, false)
            },
            handleMouseLeave(event) {
                this.isOut = true;
            }
        }

    }
</script>
<style>
    .homepage__container-why-choose-us__slider .v-btn .v-btn__content .v-icon {
        font-size: 15px;
        color: #BDBDBD;
        opacity: 1;
    }
    .homepage__container-why-choose-us__slider .v-carousel__prev, .main-carousel-slider .v-carousel__next {
        display: none;
    }
    .homepage__container-why-choose-us__slider .v-btn:before {
        display: none;
    }
    .homepage__container-why-choose-us__slider .v-btn.v-btn--active .v-btn__content .v-icon {
        color: #000000;
    }
    .homepage__container-why-choose-us__slider .v-btn:hover .v-icon {
        -webkit-text-stroke: 1px #000;
    }
    .homepage__container-why-choose-us__slider .v-btn--icon.v-btn--small {
        width: 18px;
        margin: 0 4px !important;
    }
    .homepage__container-why-choose-us__slider .main-carousel-slider-item-content {
        align-items: center;
    }
    .homepage__container-why-choose-us__slider .v-window__container .v-window-item .v-responsive__content > div {
        align-items: center;
        justify-content: center;
    }
    .homepage__container-why-choose-us__slider .v-responsive .v-image .v-carousel__item {
        height: auto !important;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/Homepage.vue